import { useState, useRef } from 'react'

const useStateRef = initialValue => {
  const [value, _setValue] = useState(initialValue)
  const valueRef = useRef(value)
  const setValue = newValue => {
    _setValue(newValue)
    valueRef.current = newValue
  }
  return [value, valueRef, setValue]
}

const useStateTrigger = initialValue => {
  const [value, _setValue] = useState(initialValue)
  const [trigger, setTrigger] = useState(false)
  const setValue = newValue => {
    _setValue(newValue)
    setTrigger(b => !b)
  }
  return [value, trigger, setValue]
}

const useStorageFoundWord = initialValue => {
  const [storedValue, setStoredValue] = useState(() => {
    try {
      return initialValue
    } catch (error) {
      console.log(error)
      return initialValue
    }
  })
  const setValue = value => {
    try {
      const valueToStore =
        value instanceof Function ? value(storedValue) : value
      setStoredValue(valueToStore)
    } catch (error) {
      console.log(error)
    }
  }
  return [storedValue, setValue]
}

const useLocalStateRef = (key, initialValue) => {
  const [value, _setValue] = useStorageFoundWord(key, initialValue)
  const valueRef = useRef(value)
  const setValue = newValue => {
    _setValue(newValue)
    valueRef.current = newValue
  }
  return [value, valueRef, setValue]
}

export { useStateRef, useStateTrigger, useStorageFoundWord, useLocalStateRef }
